import { render } from "./DropConfirmModal.vue?vue&type=template&id=95ee7c2c"
import script from "./DropConfirmModal.vue?vue&type=script&lang=js"
export * from "./DropConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__